import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Language } from '../../../../../shared/enum/language';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { SessionTokenService } from '../../../../../session/service/session-token';


@Component({
  selector: 'admin-customer-photographer-list',
  templateUrl: './photographers.component.html',
  styleUrls: [ './photographers.component.scss' ]
})
export class AdminCustomerPhotographerListComponent extends AbstractListComponent implements OnInit {

  languages: any = Language;

  getResourceUrl(): string {
    return `/admin/customer/${this.route.parent.parent.snapshot.params.id}/users`;
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              private sessionToken: SessionTokenService,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.parameters.conditions.customer = this.route.parent.parent.snapshot.params.id;
    this.parameters.conditions.role = [ 'PHOTOGRAPHER' ];

    super.ngOnInit();
  }

  login(user: any) {
    this.loading = true;
    this.httpClient.post(`/admin/user/${user.uuid}/login`, {})
      .subscribe(
        (sessionData: any) => {
          this.sessionToken.storeAdminToken(this.sessionToken.getToken());
          this.sessionToken.persist(sessionData);

          this.router.navigate([ `/campaign` ]);
        }, (error: any) => {
          this.loading = false;
        }
      );
  }
}
